import { LANGUAGES } from '../../utils/i18n';
import { useLanguage } from '../../utils/LanguageContext';
import './LanguageSelector.css';

const LanguageSelector = ({ className = '' }) => {
  const { currentLang, changeLanguage } = useLanguage();

  return (
    <div
      className={`lang-toggle${className ? ` ${className}` : ''}`}
      role="group"
      aria-label="Language"
    >
      {LANGUAGES.map((lang, i) => (
        <span key={lang} className="lang-toggle-item">
          {i > 0 && <span className="lang-toggle-sep" aria-hidden="true">/</span>}
          <button
            type="button"
            className={`lang-toggle-btn${lang === currentLang ? ' is-active' : ''}`}
            onClick={() => changeLanguage(lang)}
            aria-label={lang === 'en' ? 'switch to English' : 'zu Deutsch wechseln'}
            aria-current={lang === currentLang ? 'true' : undefined}
            disabled={lang === currentLang}
          >
            {lang}
          </button>
        </span>
      ))}
    </div>
  );
};

export default LanguageSelector;
